import * as types from "@/store/mutationTypes";
import paymentService from "@/http/services/paymentService";
import { NotificationsTypes } from "@/constants/notificationsTypes";
const PayNowInvoiceModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/PayNowInvoiceModal');

export const actions = {
    setPayNowActivityId: ({ commit }, payNowActivityId) => {
        commit(types.SET_PAY_NOW_ACTIVITY_ID, payNowActivityId);
    },

    setInvoiceData: ({ commit }, invoiceData) => {
        commit(types.SET_INVOICE_DATA, invoiceData);
    },

    getAllPaymentMethods: async ({ commit, getters, dispatch }, setDefaultMethod) => {
        try {
            const { parentId, schoolId } = getters.paymentPayload;
            const methods = await paymentService.getAllPaymentMethods(
                parentId,
                schoolId
            );
            if (methods && methods.length !== 0 && setDefaultMethod) {
                dispatch("setDefaultPaymentMethod", methods[0].id);
                return;
            }
            if (methods && methods.length !==0 && methods.every(m => !m.default)) {
                dispatch("setDefaultPaymentMethod", methods[0].id);
                return;
            }
            commit(types.SET_PAYMENT_METHODS, methods);
            dispatch("setIsPaymentMethodsLoading", false);
        } catch (error) {
            dispatch("createNotification", {
                message:
                    "Error loading payment methods. Please try again later or contact support.",
                type: NotificationsTypes.ERROR,
            });
        }
    },
    
    getClientSecret: async ({ commit, dispatch, getters }) => {
        try {
            const { parentId, schoolId } = getters.paymentPayload;
            const clientSecret = await paymentService.getClientSecret(
                parentId,
                schoolId
            );

            commit(types.SET_CLIENT_SECRET, clientSecret);
        } catch (error) {
            dispatch("createNotification", {
                message:
                    "Error loading payment data. Please try again later or contact support.",
                type: NotificationsTypes.ERROR,
            });

        }
    },

    cancelPaymentFlow: async (context, schoolSlug) => {
        try {
            const enrollmetData = context.state.payNowEnrollmentData;
            
            const payNowActivityId = context.state.payNowActivityId

    switch (enrollmetData.activityType) {
            case "Class":
                await paymentService.cancelPaymentFlow(schoolSlug, enrollmetData.activityId, enrollmetData.childId, payNowActivityId);
                context.dispatch("createNotification", {
                    message: "Payment cancelled",
                    type: NotificationsTypes.WARNING,
                });
                break;
            case "Aftercare":
                await paymentService.cancelAftercarePaymentFlow(context.getters.schoolInfo.id, enrollmetData.activityId, payNowActivityId, enrollmetData.childId);
                context.dispatch("createNotification", {
                    message: "Payment cancelled",
                    type: NotificationsTypes.WARNING,
                });
                break;
            case "DropIn":
                await paymentService.cancelAftercareDropInPaymentFlow(context.getters.schoolInfo.id, enrollmetData.activityId, payNowActivityId);
                context.dispatch("createNotification", {
                    message: "Payment cancelled",
                    type: NotificationsTypes.WARNING,
                });
                break;

                case "Camp":
                    await paymentService.cancelCampPaymentFlow(context.getters.schoolInfo.id, enrollmetData.activityId, payNowActivityId);
                    context.dispatch("createNotification", {
                        message: "Payment cancelled",
                        type: NotificationsTypes.WARNING,
                    });
                    break;
            }

        } catch (error) {
            context.dispatch("createNotification", {
                message:
                    "Error cancelling payment. Please try again later or contact support.",
                type: NotificationsTypes.ERROR,
            });
        } finally {
            context.dispatch("showSpinner", false);
        }
    },

    applyCoupon: async ({ commit, dispatch, getters }, { coupon, paymentId }) => {
        try {
            const {content} = await paymentService.getAllCoupons(getters.schoolInfo.id, coupon);
            
            const couponToApply = content.find((c) => c.name === coupon);
            if (couponToApply) {
                const invoice = await paymentService.applyCoupon(paymentId, couponToApply.stripeCoupon);
                dispatch("setInvoiceData", invoice);
                dispatch("createNotification", {
                    message: "Coupon applied successfully",
                    type: NotificationsTypes.SUCCESS,
                });
            } else {
                dispatch("createNotification", {
                    message: "Coupon not found",
                    type: NotificationsTypes.ERROR,
                });
            }

        } catch (error) {
     
            dispatch("createNotification", {
                message: "Failed to apply coupon",
                type: NotificationsTypes.ERROR,
            });
        }
    },

    createPayment: async ({ dispatch, getters }, payload) => {
        const createInvoiceData = {
            ...getters.paymentPayload,
            paymentMethodId: payload.paymentMethodId,
        };
        
        try {
            const invoice = await paymentService.createPayment(createInvoiceData);
            if (invoice) {
                dispatch("setInvoiceData", invoice);
                dispatch("openModal", {
                    modal: PayNowInvoiceModal,
                    options: {
                        confirmOnClose: true,
                        isWaitlistFlow: payload.isWaitlistFlow,
                        rosterDay: payload.rosterDay,
                    }
                });
            }
        } catch (error) {
            dispatch("createNotification", {
                message:
                    "Error creating payment. Please try again later or contact support.",
                type: NotificationsTypes.ERROR,
            });
        }
    },
    
    confirmPayment: async ({ dispatch, state }, paymentId) => {
        try {
            const activityType = state.paymentPayload.activityType;

            await paymentService.confirmPayment(paymentId);
            dispatch("createNotification", {
                message: "Payment confirmed successfully",
                type: NotificationsTypes.SUCCESS,
            });
            dispatch("closeModal", { dangerClose: true });

            switch (activityType) {
                case "Class":
                    dispatch("getClassesBySchool");
                    break;
                case "Aftercare":
                    dispatch("getAftercareBySchool");
                    break;
                case "Camp":
                    dispatch("getCampsBySchool");
                    break;
                default:
                    break;
            }
        } catch (error) {
            dispatch("createNotification", {
                message:
                    "Error confirming payment. Please try again later or contact support.",
                type: NotificationsTypes.ERROR,
            });
        }
    },

    deletePaymentMethod: async ({ dispatch, getters }, paymentMethodId) => {
        const { parentId, schoolId } = getters.paymentPayload;
        try {
            await paymentService.deletePaymentMethod(parentId, schoolId, paymentMethodId);
            dispatch("getAllPaymentMethods");
            dispatch("createNotification", {
                message:
                    "Payment method successfully deleted. You can add a new one",
                type: NotificationsTypes.SUCCESS,
            });
        } catch (error) {
            dispatch("createNotification", {
                message:
                    "Error deleting payment method. Please try again later or contact support.",
                type: NotificationsTypes.ERROR,
            });
        }
    },

    setDefaultPaymentMethod: async ({ dispatch, getters }, paymentMethodId) => {
        const { parentId, schoolId } = getters.paymentPayload;
        try {
            await paymentService.setDefaultPaymenyMethod(parentId, schoolId, paymentMethodId);
            dispatch("getAllPaymentMethods");
        } catch (error) {
            dispatch("createNotification", {
                message:
                    "Error updating default payment method. Please try again later or contact support.",
                type: NotificationsTypes.ERROR,
            });
        }
    },

    setPayNowEnrollemtData: ({ commit }, payNowEnrollmentData) => {
        commit(types.SET_PAY_NOW_ENROLLMENT_DATA, payNowEnrollmentData);
    },

    initRelevantData: async ({ dispatch, commit, getters, state }, { userId, setDefaultMethod }) => {
        try {
            await dispatch('getSchoolInfo');
            const schoolId = getters.schoolInfo.id;
            const activityId = state.payNowActivityId;
            const enrollmetData = state.payNowEnrollmentData;
            commit(types.SET_PAYMENT_PAYLOAD, {
                parentId: userId,
                schoolId,
                activityType: enrollmetData.activityType,
                activityId,
            });
            await dispatch('getAllPaymentMethods', setDefaultMethod);

        } catch (error) {
            dispatch("createNotification", {
                message:
                    "Error loading data. Please try again later or contact support.",
                type: NotificationsTypes.ERROR,
            });
        }
    },

    getAllCoupons: async ({ commit, getters }) => {
        try {
            const coupons = await paymentService.getAllCoupons(getters.schoolId);
            commit(types.SET_COUPONS, coupons);
        } catch (error) {
            dispatchEvent("createNotification", {
                message:
                    "Error loading coupons. Please try again later or contact support.",
                type: NotificationsTypes.ERROR,
            });
        }
    },

    setIsPaymentMethodsLoading({ commit }, isLoading) {
        commit(types.SET_IS_PAYMENT_METHODS_LOADING, isLoading);
    },

    cancelWaitlistPaymentFlow: async (context, payload) => {
        
        try {
            const schoolId = context.rootState.authentication.schoolInfo.id;
            const { activityType, childId, activityId, campPricingId } = context.state.payNowEnrollmentData;
            const payNowActivityId = context.state.payNowActivityId;

            if (schoolId) {
                
            switch (activityType) {
                case "Class":
                    await paymentService.removeChildWithoutPaymentFromClass(schoolId, activityId, payNowActivityId, childId);
                    break;
                case "Aftercare":
                    await paymentService.removeChildWithoutPaymentFromAftercareRosters(schoolId, payNowActivityId, childId, payload);
                    break;
                case "Camp":
                    await paymentService.removeChildWithoutPaymentFromCamp(schoolId, campPricingId, payNowActivityId, childId);
                    break;
                default:
                    break;
            }
            context.dispatch("createNotification", {
                message:
                    `The child has been removed from the roster, and your spot in the ${activityType}/Waitlist has been lost`,
                type: NotificationsTypes.SUCCESS,
                timer: 6000
            });
            }

        } catch (error) {
            context.dispatch("createNotification", {
                message:
                    "Error cancelling payment. Please try again later or contact support.",
                type: NotificationsTypes.ERROR,
            });
        } finally {
            context.dispatch("showSpinner", false);
        }  
    }
}
    



// WEBPACK FOOTER //
// ./src/store/modules/payment/actions.js